import { AlpineComponent } from '@alpinejs/csp';

import triggerCustom from '../../../javascripts/events/triggerCustom';
import select from '../../../javascripts/dom/select';
import validateForm from '../../../javascripts/events/validateForm';

const Form = (): AlpineComponent => ({
  classList: {
    error: 'form-error'
  },

  /**
   * Custom form validation using constraint validation API.
   * https://caniuse.com/#feat=constraint-validation
   * Adds class .form-error to every input if invalid
   * Error handling is done in input atoms.
   * If all inputs are valid, submits form
   * @param {Object} event optional event
   * @param {Function} cb An optional callback that can be triggered instead of submitting the form if it's valid
   * @returns {void}
   * @memberof Form
   */
  validate(event: SubmitEvent) {
    const isValid = validateForm(event, this.$root);

    if (isValid) {
      triggerCustom(this.$root, 'success', event);
      this.$root.submit();
    }
  },

  initEventListeners() {
    this.formElements.forEach((element: Element) =>
      element.addEventListener('focusin', () => {
        element.classList.remove(this.classList.error);
      })
    );
  },

  init() {
    this.formElements = select('input, select, textarea', this.$root);
    this.initEventListeners();
  }
});

export default Form;
